// resourceDisplayTitle — the ONE place a resource's stored title becomes its
// displayed name (P34 / inevitability I2: a kind is spelled ONCE).
//
// A resource's KIND is carried structurally — the row's registry glyph (P33)
// and the section it sits under. Some stored titles ALSO carry a redundant
// " (kind)" suffix from an older creation default (a material derived from
// "diffusion.txt" was stored as "diffusion.txt (material)"). That suffix is the
// kind spelled a second time: the glyph says "material" and the text repeats
// "(material)". This strips it for DISPLAY only.
//
// Pure, and display-only by contract: the STORED title is never touched (the
// event log keeps "diffusion.txt (material)"; only a rename changes it). Apply
// this at the projection/label layer — where a stored title becomes a nav ref,
// a palette item, or an editor heading — so every surface reads one clean name.
//
// The suffix is matched against the resource's OWN kind (the English kind word,
// as the creation default wrote it), so it only ever removes the redundant
// repeat — a title that merely happens to end in "(material)" for another kind
// is left untouched.

import type { ResourceKind } from "./types.js";

// A port-carried `undefined` title is an untitled resource; the caller passes
// the localized `untitled` fallback (ports carry data, views carry words).
export const resourceDisplayTitle = (
    title: string | undefined,
    kind: ResourceKind,
    untitled: string,
): string => {
    if (title === undefined) return untitled;
    const suffix = ` (${kind})`;
    return title.endsWith(suffix) ? title.slice(0, -suffix.length) : title;
};
